import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import moment from 'moment';
import { Control, Controller, FieldValues } from 'react-hook-form';

import { EnumSelect } from '~/components/GenericForm/EnumSelect';
import { convertToDateOrNull } from '~/utils/helper';

import { CustomFieldTypes, InputProps } from '../types';

//TODO FIX ALIGNMENT HACKISH HELPER TEXT

export const CustomDataFieldComponent = ({
  type,
  control,
  inputProps,
  label,
}: {
  type: string;
  control: Control<FieldValues>;
  inputProps: InputProps;
  label: string;
}) => {
  const { validationRules, defaultValue, options, ...inputProperties } =
    inputProps;

  switch (type) {
    case CustomFieldTypes.DATE:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <DatePicker
              {...inputProperties}
              label={label}
              value={convertToDateOrNull(value)}
              onChange={(v) => onChange(moment(v).format('YYYY-MM-DD'))}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={!!error?.message}
                  helperText={error?.message || ' '}
                  fullWidth={inputProps.fullWidth}
                />
              )}
            />
          )}
        />
      );
    case CustomFieldTypes.TEXT:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              onChange={onChange}
              inputProps={{
                maxLength: validationRules
                  ? validationRules['maxLength' as keyof object]
                  : undefined,
              }}
              value={value}
              label={label}
              multiline
              fullWidth
              disabled={inputProperties.disabled}
              maxRows={5}
              error={!!error?.message}
              helperText={
                validationRules && validationRules['maxLength' as keyof object]
                  ? `${value ? value.length : 0}/${
                      validationRules['maxLength' as keyof object]
                    }`
                  : ' '
              } // TODO include error?.message into helperText somehow
            />
          )}
        />
      );
    case CustomFieldTypes.STRING:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              onChange={onChange}
              inputProps={{
                maxLength: validationRules
                  ? validationRules['maxLength' as keyof object]
                  : undefined,
              }}
              value={value}
              label={label}
              fullWidth
              disabled={inputProperties.disabled}
              error={!!error?.message}
              helperText={
                validationRules && validationRules['maxLength' as keyof object]
                  ? `${value ? value.length : 0}/${
                      validationRules['maxLength' as keyof object]
                    }`
                  : ' '
              }
              // TODO include error?.message into helperText somehow
            />
          )}
        />
      );
    case CustomFieldTypes.NUMBER:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              onChange={(e) =>
                e.target.value === ''
                  ? onChange(null)
                  : onChange(e.target.value.replace(',', '.'))
              }
              label={label}
              fullWidth
              value={value || ''}
              error={!!error?.message}
              helperText={error?.message || ' '}
              disabled={inputProperties.disabled}
            />
          )}
        />
      );
    case CustomFieldTypes.BOOLEAN:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value } }) => (
            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    onChange={(_e, checked) => onChange(checked.toString())}
                    checked={value === 'true'}
                    disabled={inputProperties.disabled}
                  />
                }
                label={label}
              />
              <FormHelperText> </FormHelperText>
            </FormControl>
          )}
        />
      );
    case CustomFieldTypes.ENUM:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <EnumSelect
              {...inputProperties}
              FormControlProps={{ fullWidth: true }}
              value={value}
              onChange={onChange}
              enumOptions={options}
              label={label}
              error={!!error?.message}
              helperText={error?.message || ' '}
            />
          )}
        />
      );
    case CustomFieldTypes.MULTISELECT:
      return (
        <Controller
          name={inputProps.name}
          control={control}
          defaultValue={defaultValue}
          rules={validationRules ? { ...validationRules } : {}}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <EnumSelect
              {...inputProperties}
              FormControlProps={{ fullWidth: true }}
              value={value || []}
              onChange={onChange}
              enumOptions={options}
              label={label}
              multiple
              error={!!error?.message}
              helperText={error?.message || ' '}
            />
          )}
        />
      );

    default:
      return <h1>No project match</h1>;
  }
};
